import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=678287cf&scoped=true"
import script from "./RequestAccess.vue?vue&type=script&lang=js"
export * from "./RequestAccess.vue?vue&type=script&lang=js"
import style0 from "./RequestAccess.vue?vue&type=style&index=0&id=678287cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678287cf",
  null
  
)

export default component.exports